import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { adminApi, errorMessage } from "../../lib/api";

export const TelegramUpdates = ({ base = "/hk/telegram", tid = "hk-telegram", what = "booking confirmations, reminders and refund updates" }) => {
  const [s, setS] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const poll = useRef(null);
  useEffect(() => {
    adminApi.get(base).then((r) => setS(r.data)).catch(() => {});
    return () => clearInterval(poll.current);
  }, [base]);
  const check = () => adminApi.post(`${base}/check`).then((r) => {
    if (r.data.linked) { clearInterval(poll.current); setWaiting(false); setS(r.data); toast.success("Telegram connected"); }
  }).catch(() => {});
  const connect = async () => {
    const w = window.open("about:blank", "_blank");
    try {
      const r = await adminApi.post(`${base}/link`);
      if (w) w.location.href = r.data.url; else window.location.href = r.data.url;
      setWaiting(true);
      clearInterval(poll.current);
      let n = 0;
      poll.current = setInterval(() => { n += 1; if (n > 40) { clearInterval(poll.current); setWaiting(false); } else check(); }, 4000);
    } catch (e) { if (w) w.close(); toast.error(errorMessage(e)); }
  };
  const unlink = () => adminApi.delete(base).then((r) => { setS(r.data); toast.success("Telegram disconnected"); }).catch((e) => toast.error(errorMessage(e)));
  if (!s) return null;
  return (
    <div data-testid={tid} className="flex flex-wrap items-center justify-between gap-3 border border-sky-500/30 bg-sky-500/5 p-4 text-sm">
      <span className="flex items-center gap-2 text-slate-200"><Send className="h-4 w-4 text-sky-400" />
        {s.linked ? <span data-testid={`${tid}-linked`}>Updates on Telegram: connected{s.name ? ` (${s.name})` : ""}</span>
          : waiting ? "In Telegram tap START, then come back here…" : `Get ${what} on Telegram.`}
      </span>
      {s.linked ? (
        <button onClick={unlink} data-testid={`${tid}-unlink`} className="border border-white/15 px-3 py-1.5 text-slate-300 hover:border-red-400">Disconnect</button>
      ) : (
        <span className="flex gap-2">
          {waiting && <button onClick={check} data-testid={`${tid}-check`} className="border border-white/15 px-3 py-1.5 text-slate-200">I pressed Start</button>}
          <button onClick={connect} data-testid={`${tid}-connect`} className="bg-sky-500 px-4 py-1.5 font-semibold text-white hover:bg-sky-600">Connect Telegram</button>
        </span>
      )}
    </div>
  );
};
